import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";

export function LandLotOwnersHeaderColumnGroupTemplate() {
    return (
        <ColumnGroup>
            <Row>
                <Column header="Правообладатель" colSpan={2} align="center" />
                <Column header="Правоудостоверяющий документ" colSpan={3} align="center" />
                <Column header="Правоустанавливающий документ" colSpan={3} align="center" />
            </Row>
            <Row>
                <Column header="Правообладатель" colSpan={1} rowSpan={1} align="center" field="UserName" />
                <Column header="Право" colSpan={1} rowSpan={1} align="center" field="RightTypeString" />
                <Column header="Реквизиты" colSpan={1} rowSpan={1} align="center" field="RightCertificationDocRequisites" />
                <Column header="Просмотреть" colSpan={1} rowSpan={1} align="center" field="RightCertificationDocView" />
                <Column header="Скачать" colSpan={1} rowSpan={1} align="center" field="RightCertificationDocDownload" />
                <Column header="Реквизиты" colSpan={1} rowSpan={1} align="center" field="RightEstablishmentDocRequisites" />
                <Column header="Просмотреть" colSpan={1} rowSpan={1} align="center" field="RightEstablishmentDocView" />
                <Column header="Скачать" colSpan={1} rowSpan={1} align="center" field="RightEstablishmentDocDownload" />
            </Row>
        </ColumnGroup>
    )
}